
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Initialize Sentry after React is loaded
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://986d93b3e581389f83bd45fbe6a6c938@o4509646815428608.ingest.us.sentry.io/4509646970290176",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);
